export default {
  title: 'การชำระเงิน',
  description: 'ดูและจัดการบันทึกการชำระเงินทั้งหมด',

  labels: {
    date: 'วันที่',
    invoice: 'ใบแจ้งหนี้',
    customer: 'ลูกค้า',
    unit: 'ห้อง',
    amount: 'จำนวนเงิน',
    method: 'วิธีชำระ',
    reference: 'หมายเหตุ / อ้างอิง',
    verification_status: 'การตรวจสอบ',
    status: 'สถานะ',
  },

  filters: {
    all_methods: 'ทุกวิธี',
    all_periods: 'ทั้งหมด',
    custom_range: 'กำหนดเอง',
    billing_period: 'รอบบิล',
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
    search_placeholder: 'ค้นหาเลขอ้างอิง...',
    all_verification_statuses: 'ทุกสถานะ',
    verification_status: 'สถานะการตรวจสอบ',
    fraud_suspect: 'สงสัยสลิปปลอม',
    unidentified: 'ยังไม่ระบุผู้จ่าย',
    // EP-161 §2.4: กรองรายการชำระจากตู้จอดรถ (channel=parking_kiosk)
    channel: {
      label: 'ช่องทาง',
      all: 'ทั้งหมด',
      parking_kiosk: 'ค่าจอดรถ',
    },
  },

  methods: {
    cash: 'เงินสด',
    transfer: 'โอนเงิน',
    promptpay: 'พร้อมเพย์',
    credit_card: 'บัตรเครดิต',
    qr_image: 'ชำระผ่าน QR (ที่จอดรถ)',
  },

  actions: {
    print_selected: 'พิมพ์ใบเสร็จ ({{count}})',
    print_all: 'พิมพ์ทั้งหมด',
    print_all_description: 'สร้างใบเสร็จสำหรับการชำระเงินทั้งหมด {{count}} รายการ และเปิดเป็น PDF ในแท็บใหม่',
    export: 'ส่งออก',
    download_receipt: 'ใบเสร็จ',
    verify: 'อนุมัติ',
    reject: 'ปฏิเสธ',
    retry_verification: 'ตรวจสอบใหม่',
    new_payment: 'เพิ่มการชำระเงิน',
    edit_payment: 'แก้ไขการชำระเงิน',
    delete_payment: 'ลบการชำระเงิน',
    flag_fraud: 'ทำเครื่องหมายว่าเป็นสลิปปลอม',
  },

  fraud: {
    confirm_title: 'ทำเครื่องหมายว่าเป็นสลิปปลอม',
    confirm_body: 'การดำเนินการนี้จะบันทึกข้อมูลผู้ส่งและลายเซ็นสลิปลงในทะเบียนการทุจริต สลิปที่มาจากผู้ส่งเดิมในอนาคตจะถูกบล็อกโดยอัตโนมัติ ต้องการดำเนินการต่อหรือไม่?',
    flagged_success: 'ทำเครื่องหมายการชำระเงินว่าเป็นสลิปปลอมและเพิ่มลงในทะเบียนการทุจริตแล้ว',
  },

  form: {
    invoice: 'ใบแจ้งหนี้',
    select_invoice: 'ใบแจ้งหนี้',
    invoice_search_placeholder: 'ค้นหาใบแจ้งหนี้ที่ค้างชำระ…',
    no_invoice_option: 'ไม่มีใบแจ้งหนี้',
  },

  confirm: {
    delete: 'ลบการชำระเงินนี้? ยอดคงเหลือของใบแจ้งหนี้จะถูกปรับปรุง',
  },

  errors: {
    admin_only: 'เฉพาะผู้ดูแลระบบหรือเจ้าของเท่านั้นที่สร้างหรือแก้ไขการชำระเงินได้',
    verified_amount_locked: 'ไม่สามารถแก้ไขจำนวนเงินและวิธีชำระเงินของการชำระเงินที่ตรวจสอบแล้ว',
    property_required: 'กรุณาเลือกอสังหาริมทรัพย์สำหรับการชำระเงินนี้',
    property_not_found: 'ไม่พบอสังหาริมทรัพย์นี้ในบัญชีของคุณ',
    unidentified_payment_only: 'การชำระเงินนี้มีลูกค้าหรือใบแจ้งหนี้อยู่แล้ว',
    customer_not_found: 'กรุณาเลือกลูกค้า',
    invoice_customer_mismatch: 'ใบแจ้งหนี้นี้เป็นของลูกค้าคนอื่น',
  },

  identify_payer: {
    action: 'ระบุผู้จ่าย',
    title: 'ระบุผู้จ่าย',
    hint: 'ระบุลูกค้า และใบแจ้งหนี้ที่จ่าย (ไม่บังคับ) ให้กับการชำระเงินนี้',
    customer_label: 'ลูกค้า',
    invoice_label: 'ใบแจ้งหนี้ (ไม่บังคับ)',
    submit: 'ระบุผู้จ่าย',
    success: 'ระบุผู้จ่ายเรียบร้อยแล้ว',
  },

  quick_pay: {
    title: 'บันทึกการชำระเงิน',
    // F2 (T149-088 QA fix): ฟอร์มที่รวมกันแล้วจ่ายใบแจ้งหนี้ได้ด้วย จึงไม่ใช่แค่กรณีไม่มีใบแจ้งหนี้อีกต่อไป
    description: 'บันทึกการชำระเงิน ไม่ว่าจะมีใบแจ้งหนี้หรือไม่',
    property_label: 'อสังหาริมทรัพย์',
    property_placeholder: 'เลือกอสังหาริมทรัพย์…',
    property_required: 'กรุณาเลือกอสังหาริมทรัพย์',
    no_property_title: 'ยังไม่มีอสังหาริมทรัพย์',
    no_property_hint: 'ต้องบันทึกการชำระเงินกับอสังหาริมทรัพย์ กรุณาสร้างอสังหาริมทรัพย์แรกของคุณเพื่อเริ่มต้น',
    no_property_cta: 'สร้างอสังหาริมทรัพย์',
    customer_label: 'ลูกค้า',
    customer_placeholder: 'ค้นหาลูกค้าด้วยชื่อหรือโทรศัพท์…',
    customer_required: 'กรุณาเลือกลูกค้า',
    unknown_payer_label: 'ไม่ทราบผู้จ่าย',
    amount_label: 'จำนวนเงิน ({{currency}})',
    reference_placeholder: 'หมายเลขเช็ค เลขอ้างอิงโอนเงิน…',
    submit: 'บันทึกการชำระเงิน',
    success: 'บันทึกการชำระเงินสำเร็จ',
    not_available_condo: 'ไม่สามารถบันทึกการชำระเงินแบบสแตนด์อโลนสำหรับบัญชีคอนโดมิเนียม',
    date_future_warning: 'วันที่นี้อยู่ในอนาคต',
  },

  not_found: 'ไม่พบการชำระเงิน',

  empty: {
    title: 'ไม่พบการชำระเงิน',
    description: 'บันทึกการชำระเงินจะปรากฏที่นี่เมื่อมีการบันทึกการชำระเงินสำหรับใบแจ้งหนี้',
    no_results: 'ไม่พบการชำระเงินที่ตรงกับการค้นหาหรือตัวกรองของคุณ',
    clear_filters: 'ล้างตัวกรอง',
  },

  setup_guide: {
    title: 'ยินดีต้อนรับสู่การชำระเงิน',
    description: 'สร้างใบแจ้งหนี้เพื่อบันทึกการชำระเงิน',
    step_1_title: 'ตั้งค่าอสังหาริมทรัพย์และลูกค้า',
    step_1_description: 'สร้างอสังหาริมทรัพย์อย่างน้อยหนึ่งรายการพร้อมห้อง และเพิ่มผู้เช่าเป็นลูกค้า',
    step_2_title: 'สร้างสัญญาเช่า',
    step_2_description: 'เชื่อมลูกค้ากับห้องผ่านสัญญาเช่าเพื่อเปิดใช้งานการเรียกเก็บเงิน',
    step_3_title: 'สร้างใบแจ้งหนี้ จากนั้นบันทึกการชำระเงิน',
    step_3_description: 'สร้างใบแจ้งหนี้จากหน้าใบแจ้งหนี้ จากนั้นใช้ปุ่มบันทึกการชำระเงินในใบแจ้งหนี้นั้น',
    go_to_invoices: 'ไปที่ใบแจ้งหนี้',
    import: 'นำเข้า',
    download_sample: 'ดาวน์โหลดตัวอย่าง',
    seed_sample: 'สร้างข้อมูลตัวอย่าง',
    seed_sample_confirm: 'ข้อมูลที่จะสร้าง: อสังหาริมทรัพย์ 1 รายการ + ลูกค้า 1 รายการ + สัญญาเช่า 1 รายการ + ใบแจ้งหนี้ 1 รายการ จากนั้นคุณสามารถบันทึกการชำระเงินได้ ดำเนินการต่อ?',
    seed_sample_success: 'สร้างข้อมูลตัวอย่างสำเร็จ คุณสามารถบันทึกการชำระเงินสำหรับใบแจ้งหนี้ตัวอย่างได้แล้ว',
    seed_sample_noop: 'คุณมีใบแจ้งหนี้อยู่แล้ว ไม่มีการเพิ่มข้อมูลตัวอย่าง',
  },

  verification: {
    title: 'ตรวจสอบสลิป',
    status: 'สถานะ',
    provider: 'ผู้ให้บริการ',
    trans_ref: 'เลขอ้างอิงธุรกรรม',
    amount: 'จำนวนเงินที่ตรวจสอบ',
    sender: 'ผู้ส่ง',
    sender_account: 'บัญชีผู้ส่ง',
    receiver: 'ผู้รับ',
    receiver_account: 'บัญชีผู้รับ',
    transfer_date: 'วันที่โอน',
    rejection_reasons: 'เหตุผลการปฏิเสธ',
    verify_confirm: 'ยืนยันการอนุมัติสลิปการชำระเงินนี้?',
    verify_reason_label: 'เหตุผล (ไม่บังคับ)',
    reject_reason: 'เหตุผลในการปฏิเสธ',
    reject_reason_placeholder: 'ระบุเหตุผลที่ปฏิเสธสลิปนี้...',
    retry_confirm: 'ส่งสลิปนี้เพื่อตรวจสอบอัตโนมัติอีกครั้ง?',
    slip_images: 'รูปสลิป',
    slip_image_alt: 'รูปสลิปที่ {{count}}',
    slip_image_lightbox_alt: 'สลิป',
    // EP-161: the ML reading beside a parking slip, for reference only.
    reference_heading: 'ผลอ่านสลิปอัตโนมัติ (ใช้อ้างอิงเท่านั้น)',
    no_reading: 'ยังไม่มีผลอ่านสลิป',
    reject_reason_visible_to_visitor: 'เหตุผลนี้จะแสดงให้ผู้จอดรถเห็นบนหน้าชำระเงิน',
    override_section: 'การแทรกแซงของผู้ดูแล',
    no_verification_data: 'ไม่มีข้อมูลการตรวจสอบ',
    gateway_confirmed: 'ชำระและตรวจสอบแล้วผ่าน {{provider}}',
    stripe_refund_note: 'FlowRent ไม่คืนเงินผ่าน Stripe หากต้องการคืนเงิน ให้โอนเงินคืนผู้เช่าเอง แล้วบันทึกเป็นค่าใช้จ่าย',
    manual_recorded: 'บันทึกด้วยตนเอง ไม่ต้องตรวจสอบสลิป',
    provider_label_ml: 'ผลอ่านโดย ML',
    provider_label_rdcw: 'ตรวจสอบโดย RDCW',
    provider_label_other: 'ตรวจสอบโดย {{provider}}',
    ml_match_matched: 'ML: ตรงกัน',
    ml_match_unmatched: 'ML: ไม่ตรงกัน',
    // EP-145 A5: one label per EP-143 ml_match outcome. The two above stay for
    // rows written under the EP-101 vocabulary, which is still in production JSON.
    ml_match_agree: 'ML: เห็นตรงกัน',
    ml_match_disagree: 'ML: ไม่เห็นตรงกัน',
    ml_match_solo_verify: 'ML: ยืนยันฝ่ายเดียว',
    ml_match_rdcw_fail: 'ML: ผ่าน แต่ธนาคารปฏิเสธ',
    ml_reading_detail: 'รายละเอียดการอ่านด้วย ML',
    reading_confidence: 'ความมั่นใจการอ่าน',
    banks: {
      scb: 'ไทยพาณิชย์ (SCB)',
      kbank: 'กสิกรไทย (KBank)',
      ktb: 'กรุงไทย (KTB)',
      bbl: 'กรุงเทพ (BBL)',
      bay: 'กรุงศรี (BAY)',
      ttb: 'ทีทีบี (ttb)',
      gsb: 'ออมสิน (GSB)',
      kkp: 'เกียรตินาคินภัทร (KKP)',
      promptpay_generic: 'พร้อมเพย์ (ทั่วไป)',
      unknown: 'ไม่ทราบ',
    },
    field_amount: 'จำนวนเงิน',
    field_datetime: 'วันที่/เวลา',
    field_bank: 'ธนาคาร',
    field_sender: 'ผู้ส่ง',
    field_receiver: 'ผู้รับ',
    field_trans_ref: 'เลขอ้างอิง',
    field_ref1: 'Ref1',
    manual_check_hint: 'เปรียบเทียบค่าที่ ML อ่านได้กับรูปสลิป แล้วติ๊กช่องที่ตรงกัน ช่องที่ติ๊กแล้วจะถูกใส่ในเหตุผลการอนุมัติ',
    ocr_value: 'ML อ่านได้',
    expected_value: 'ค่าที่คาดหวัง',
    check_field: 'ตรวจ',
    checked_field: 'ตรวจแล้ว',
    fields_checked_reason: 'ตรวจกับสลิปด้วยตนเองแล้ว: {{fields}}',
    corrections_hint: 'แก้ไขช่องที่ ML อ่านผิด กรอกค่าตามที่ปรากฏบนสลิป ข้อมูลที่บันทึกจะใช้เป็นชุดฝึกโมเดล',
    correction_placeholder: 'ค่าที่ถูกต้อง…',
    save_corrections: 'บันทึกการแก้ไข',
    corrections_saved: 'บันทึกการแก้ไขแล้ว',
    model_versions: 'เวอร์ชันโมเดล',
    model_bank_classifier: 'จำแนกธนาคาร',
    model_field_ocr: 'OCR ช่อง',
    gate_evidence_section: 'ผลตรวจประตู',
    gate_chip_pass: 'ผ่าน',
    gate_chip_fail: 'ไม่ผ่าน',
    gate_chip_unavailable: 'ไม่ทราบ',
    gate_names: {
      g0: 'G0 อ่านได้',
      g1: 'G1 QR Decode',
      g2: 'G2 OCR หลัก',
      g3: 'G3 QR–OCR ตรงกัน',
      g4: 'G4 บัญชีปลายทาง',
      g5: 'G5 ยอดเงิน',
      g6: 'G6 ความสด',
      g7: 'G7 ไม่ซ้ำ',
      g8: 'G8 ทะเบียนทุจริต',
      p9: 'P9 วงเงินอัตโนมัติ',
    },
    fraud_suspect_banner: 'สงสัยสลิปปลอม: สลิปนี้มีสัญญาณทุจริต โปรดตรวจสอบอย่างละเอียดก่อนอนุมัติ',
    statuses: {
      pending: 'รอตรวจสอบ',
      verifying: 'กำลังตรวจสอบ',
      verified: 'ผ่านการตรวจสอบ',
      rejected: 'ถูกปฏิเสธ',
      failed: 'ล้มเหลว',
      missing_slip: 'ไม่มีสลิป',
      manual: 'บันทึกเอง',
      gateway: 'Stripe',
    },
    reasons: {
      slip_invalid: 'รูปสลิปไม่ใช่สลิปโอนเงินที่ถูกต้อง',
      duplicate_trans_ref: 'เลขอ้างอิงซ้ำ สลิปนี้ถูกใช้ไปแล้ว',
      amount_mismatch: 'จำนวนเงินในสลิปไม่ตรงกับยอดชำระ',
      ref1_mismatch: 'รหัสอ้างอิง (Ref1) ในสลิปไม่ตรงกับรายการชำระนี้',
      image_retrieval_failed: 'รูปสลิปเสียหายหรือไม่สามารถเรียกดูได้',
      // EP-145 A1: gate-outcome reason terms emitted by SlipGateLadder.
      // One key per outcome the ladder can report, so a reason never renders
      // as a raw term. Keep in sync with SlipGateLadder::REASON_TERMS.
      unknown_bank: 'ไม่สามารถระบุธนาคารจากรูปสลิปได้',
      low_confidence: 'ความมั่นใจในการอ่านสลิปต่ำกว่าเกณฑ์ที่กำหนด',
      no_qr_trans_ref: 'อ่านเลขอ้างอิงจาก QR ในสลิปไม่ได้',
      amount_missing_or_low_confidence: 'อ่านจำนวนเงินจากสลิปได้ไม่ชัดเจนพอ',
      datetime_missing_or_low_confidence: 'อ่านวันและเวลาโอนจากสลิปได้ไม่ชัดเจนพอ',
      qr_ocr_mismatch: 'ข้อมูลใน QR กับข้อความบนสลิปไม่ตรงกัน',
      qr_ocr_review: 'ข้อมูลใน QR กับข้อความบนสลิปต่างกันเล็กน้อย',
      qr_ocr_match_unavailable: 'ไม่สามารถตรวจสอบข้อมูล QR เทียบกับข้อความบนสลิปได้',
      g3_not_viable_for_bank: 'การตรวจสอบ QR เทียบกับข้อความบนสลิปยังไม่แม่นยำพอสำหรับธนาคารนี้ จึงข้ามขั้นตอนนี้',
      trans_ref_low_confidence: 'อ่านเลขที่รายการบนสลิปได้ไม่ชัดเจนพอที่จะนำไปตรวจสอบเทียบกับ QR',
      no_recipient_registry: 'ยังไม่ได้ลงทะเบียนบัญชีรับเงิน จึงตรวจสอบบัญชีปลายทางไม่ได้',
      no_receiver_account_in_reading: 'อ่านเลขบัญชีปลายทางจากสลิปไม่ได้',
      recipient_not_registered: 'สลิปโอนเข้าบัญชีที่ไม่ได้อยู่ในรายการบัญชีรับเงินที่ลงทะเบียนไว้',
      amount_parsed_missing: 'อ่านจำนวนเงินจากสลิปไม่ได้',
      no_anchor_for_rental_static_transfer: 'การโอนนี้ไม่มี QR ชำระเงินสำหรับใช้ตรวจสอบเวลา',
      slip_datetime_missing: 'สลิปไม่ได้ระบุวันและเวลาโอน',
      slip_datetime_unparseable: 'ไม่สามารถอ่านวันและเวลาโอนบนสลิปได้',
      slip_predates_intent: 'สลิปมีวันที่ก่อนการสร้างรายการชำระนี้',
      slip_expired: 'สลิปมีวันที่นอกช่วงเวลาที่กำหนดของรายการชำระนี้',
      no_trans_ref: 'สลิปไม่มีเลขอ้างอิงสำหรับตรวจสอบรายการซ้ำ',
      account_id_unresolvable: 'ไม่สามารถเชื่อมรายการชำระกับบัญชีผู้ใช้ได้ จึงข้ามการตรวจสอบรายการซ้ำ',
      fraud_registry_hit: 'สลิปตรงกับรายการในทะเบียนสลิปทุจริต',
      amount_cap: 'จำนวนเงินสูงกว่าเกณฑ์ที่อนุมัติอัตโนมัติได้',
    },
  },

  // EP-161 §2.4: ทะเบียนรถและโซนของรายการค่าจอดรถ
  columns: {
    plate: 'ทะเบียน',
  },

  detail: {
    parking_block: {
      title: 'ค่าจอดรถ',
      plate: 'ทะเบียน',
      zone: 'โซน',
      open_sessions: 'ดูในหน้าที่จอดรถวันนี้',
    },
  },
}
